export class Pessoa {
    id = 0;
    nome = '';
    tipo = '';  
}